<template>
  <span>
    <v-card class="elevation-13">
        <v-img class="text-right pa-3" :src="getThumbnailURL(courseData.thumbNail)" height="300px">
            <TourModal :tourCourse="courseData"></TourModal>
            <v-container fill-height fluid>
                <v-layout align-center>
                    <v-flex class="">
                        <p class="activitycard-title display-2 font-weight-bold white--text text-center">{{ courseData.name }}</p>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-img>

        <v-card-title primary-title>
            <div>
                <v-card-subtitle class="mt-1">
                  <span v-for="(destination, i) in courseData.itinerary">
                    <span v-if="i == courseData.itinerary.length - 1">
                      <v-chip>{{ $t('tours.' + destination.folderName) }}</v-chip>
                    </span>
                    <span v-else>
                      <v-chip>{{ $t('tours.' + destination.folderName) }}</v-chip><v-icon>mdi-forward</v-icon>
                    </span>
                  </span>
                </v-card-subtitle>
            </div>
        </v-card-title>
    </v-card>
</span>
</template>

<script>
import TourModal from '../modal/TourModal.vue';
export default {
  name: 'HomeActivitiesCard',
  props: ['courseData'],
  components: {
      TourModal
  },
  computed: {
    topTourCourses() {
      let tourCourses = this.$store.getters.tourCourses;
      let topTourCourses = [tourCourses[0], tourCourses[1], tourCourses[3], tourCourses[4], tourCourses[5]]
      return topTourCourses;
    }

  },
  data: () => ({


  }),
  methods: {
    getThumbnailURL: function(thumbNail) {
      return require('../../assets/destinations' + thumbNail)
    }
  }
};
</script>

<style scoped>
#home-carousel {
}
.activitycard-title {
    text-shadow: 2px 2px 8px black;
}
</style>
